import { AppFragment } from 'enums/path-fragment';
import { DynamicIppicaDetailsRendererAntepost } from './ippicaDetailsRendererAntepost/IppicaDetailsRendererAntepost';
import { DynamicIppicaDetailsRendererCorse } from './ippicaDetailsRendererCorse/IppicaDetailsRendererCorse';
import { DynamicIppicaHeader } from '../ippicaHeader/IppicaHeader';
import { DynamicIppicaHeaderSticky } from '../ippicaHeaderSticky/IppicaHeaderSticky';
import { memo } from 'react';
import { selectIsAntepost } from 'features/ippica/selectors';
import styles from './IppicaDetailsRenderer.module.scss';
import { useTypedSelector } from 'lib/centralStore';
import useWindowSize from 'hooks/useWindowSize';

export const IppicaDetailsRenderer = memo(function IppicaDetailsRenderer() {
  const { isMobile } = useWindowSize();

  const isAntepost = useTypedSelector(selectIsAntepost);

  return (
    <>
      {isMobile ? (
        <DynamicIppicaHeaderSticky linkBack={`/${AppFragment.Ippica}`} />
      ) : (
        <DynamicIppicaHeader containerClassName={styles.infoHeader} hasMarginRight />
      )}
      {isAntepost ? <DynamicIppicaDetailsRendererAntepost /> : <DynamicIppicaDetailsRendererCorse />}
    </>
  );
});
